import { render, staticRenderFns } from "./Standards.vue?vue&type=template&id=4bcc57d8"
import script from "./Standards.vue?vue&type=script&lang=js"
export * from "./Standards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports